'use strict';

var constants = require('./constants.cjs');
var axiosError = require('./utils/axiosError.cjs');
var customError = require('./utils/customError.cjs');
var sentry = require('./utils/sentry.cjs');
var apiError = require('./utils/apiError.cjs');
var flexHttpError = require('./utils/flexHttpError.cjs');
var reactQuery = require('./utils/reactQuery.cjs');



exports.CustomErrorType = constants.CustomErrorType;
exports.CustomHttpHeaderType = constants.CustomHttpHeaderType;
exports.HttpErrorType = constants.HttpErrorType;
exports.JSON_PARSING_FAILED_BLOB_ERROR = constants.JSON_PARSING_FAILED_BLOB_ERROR;
exports.NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES = constants.NEGLIGIBLE_SENTRY_CAPTURE_ERROR_CODES;
exports.NEGLIGIBLE_SENTRY_CAPTURE_ERROR_TYPES = constants.NEGLIGIBLE_SENTRY_CAPTURE_ERROR_TYPES;
exports.RESERVED_ERROR_CODE = constants.RESERVED_ERROR_CODE;
exports.UNKNOWN_ERROR = constants.UNKNOWN_ERROR;
exports.getErrorCodeFromBlobResponse = axiosError.getErrorCodeFromBlobResponse;
exports.getErrorMessageFromBlobResponse = axiosError.getErrorMessageFromBlobResponse;
exports.getHasMessage = axiosError.getHasMessage;
exports.isAxiosError = axiosError.isAxiosError;
exports.isAxiosErrorWithBlob = axiosError.isAxiosErrorWithBlob;
exports.isAxiosErrorWithErrorCode = axiosError.isAxiosErrorWithErrorCode;
exports.isAxiosErrorWithErrorMessage = axiosError.isAxiosErrorWithErrorMessage;
exports.isAxiosErrorWithResponse = axiosError.isAxiosErrorWithResponse;
exports.isAxiosErrorWithViolations = axiosError.isAxiosErrorWithViolations;
exports.isAccessTokenTypeError = customError.isAccessTokenTypeError;
exports.isRouteChangeCanceledError = customError.isRouteChangeCanceledError;
exports.isNegligibleSentryCapture = sentry.isNegligibleSentryCapture;
exports.decideError = apiError.decideError;
exports.isFlexHttpError = flexHttpError.isFlexHttpError;
exports.getIgnoreReactQueryErrorHandler = reactQuery.getIgnoreReactQueryErrorHandler;
//# sourceMappingURL=index.cjs.map
